import { ProjectManagementState } from '@/store/ProjectManagement/ProjectManagementRoot';
import { GetterTree } from 'vuex';

import { IPMChartVersionRow } from '@/ship/Models/IProjectManagement';
import { Structure } from '@/ship/Models/ProjectManagement';
import { ChartVersionStatusEnum } from '@/ship/Enums/ProjectManagement/ChartVersionEnum';
import { PMChartBpcStatusEnum, PMChartStatusEnum } from '@/ship/Enums/ProjectManagementEnums';

export const getters: GetterTree<ProjectManagementState, ProjectManagementState> = {
    chartVersions(state): IPMChartVersionRow[] {
        return state.chart ? [...state.chart.versions!.data].map((version) => ({ ...version, selected: false })) : [];
    },

    isStructureExist(state): boolean {
        return !!state.chartVersion?.tasks?.data.length;
    },

    getStructureTasks(state): Structure[] {
        return state.chartVersionTasks ?? [];
    },

    isVersionOnApproval(state): boolean {
        return (
            state.chart?.versions?.data.some(
                ({ approvalStatus }) => approvalStatus === ChartVersionStatusEnum.onApproval,
            ) ?? false
        );
    },

    isChartStatusCancelled(state): boolean {
        return state?.chart?.status === PMChartStatusEnum.cancelled;
    },

    isChartStatusCompleted(state): boolean {
        return state?.chart?.status === PMChartStatusEnum.completed;
    },

    someDpcOnApproval(state): boolean {
        return state.dpcList?.some(({ status }) => status === PMChartBpcStatusEnum.onApproval) ?? false;
    },

    someDpcExecOnApproval(state): boolean {
        return state.dpcExecList?.some(({ status }) => status === PMChartBpcStatusEnum.onApproval) ?? false;
    },
};
export default getters;
